/** Filipino for the office merchant and monitoring screens, keyed by the English text. */
export const FIL_MERCHANTS_OFFICE: Record<string, string> = {
  "Above the cap": "Lampas sa takdang presyo",
  "Accepted": "Tinanggap",
  "Accredit": "I-accredit",
  "Accreditation": "Akreditasyon",
  "Accreditation no.": "Blg. ng akreditasyon",
  "Accredited merchants": "Mga accredited na tindahan",
  "Accredited on": "Na-accredit noong",
  "Action": "Aksyon",
  "Active": "Aktibo",
  "Active cards": "Mga aktibong card",
  "Add a merchant": "Magdagdag ng tindahan",
  "Add product": "Magdagdag ng produkto",
  "Address": "Address",
  "Agreement (MOA)": "Kasunduan (MOA)",
  "All barangays": "Lahat ng barangay",
  "All billings": "Lahat ng billing",
  "All categories": "Lahat ng kategorya",
  "All merchants": "Lahat ng tindahan",
  "All programs": "Lahat ng programa",
  "All rules": "Lahat ng tuntunin",
  "All sales in the list will be approved.": "Aaprubahan ang lahat ng benta sa listahan.",
  "Amount": "Halaga",
  "Analytics": "Analytics",
  "Any barangay": "Kahit anong barangay",
  "Any status": "Kahit anong status",
  "Any type": "Kahit anong uri",
  "Appeal from the owner": "Apela ng may-ari",
  "Applies when you choose Investigate. Sales already billed are not affected.": "Para lang kapag pinili ang Imbestigahan. Hindi apektado ang mga na-bill na.",
  "Approve": "Aprubahan",
  "Approve this mapping?": "Aprubahan ang mapping na ito?",
  "Approve, holding {n} sales": "Aprubahan, ipigil ang {n} benta",
  "Approved": "Aprubado",
  "Approved product": "Aprubadong produkto",
  "Approved products": "Mga aprubadong produkto",
  "Ask for approval": "Humingi ng pag-apruba",
  "Attach evidence (photo or PDF)": "Maglakip ng ebidensya (litrato o PDF)",
  "Average basket": "Karaniwang halaga ng bili",
  "Bank": "Bangko",
  "Bank reference": "Reference ng bangko",
  "Bank transfer reference": "Reference ng bank transfer",
  "Bank transfer reference (ADA)": "Reference ng bank transfer (ADA)",
  "Barangay": "Barangay",
  "Barangays": "Mga barangay",
  "Barcodes": "Mga barcode",
  "Billed": "Na-bill",
  "Billed by merchants": "Na-bill ng mga tindahan",
  "Billing": "Billing",
  "Billing number": "Numero ng billing",
  "Billing {n}": "Billing {n}",
  "Billings pending": "Mga nakabinbing billing",
  "Brand": "Brand",
  "Budget": "Badyet",
  "Business name": "Pangalan ng negosyo",
  "By category": "Ayon sa kategorya",
  "By program": "Ayon sa programa",
  "Cashier": "Kahera",
  "Category": "Kategorya",
  "Change on {d}": "Magbabago sa {d}",
  "Check each store's items against the approved list before they can be paid with assistance.": "Suriin ang mga item ng bawat tindahan laban sa aprubadong listahan bago ito mabayaran ng ayuda.",
  "Check no.": "Blg. ng tseke",
  "Check number": "Numero ng tseke",
  "Check the file": "Suriin ang file",
  "Checks finished: {n} new flags.": "Tapos ang pagsusuri: {n} bagong flag.",
  "Choose…": "Pumili…",
  "Claims from merchants for constituents' purchases. Payment is made by the LGU's bank.": "Mga singil ng tindahan para sa binili ng mga constituent. Ang bangko ng LGU ang nagbabayad.",
  "Cleared": "Na-clear",
  "Code": "Code",
  "Coming election spending ban: {name}, {start} to {end}.": "Paparating na election spending ban: {name}, {start} hanggang {end}.",
  "Confirm": "Kumpirmahin",
  "Constituent": "Constituent",
  "Constituents served": "Mga napagsilbihang constituent",
  "Create merchant": "Gumawa ng tindahan",
  "Credited": "Na-credit",
  "Credited (solid line)": "Na-credit (buong linya)",
  "Credited and spent over time": "Na-credit at nagastos sa paglipas ng panahon",
  "Dashboard": "Dashboard",
  "Day": "Araw",
  "Detail: {x}": "Detalye: {x}",
  "Differences": "Mga pagkakaiba",
  "Document: {x}": "Dokumento: {x}",
  "Documents": "Mga dokumento",
  "Done": "Tapos",
  "Done: {n} rows. The file opened in a new tab.": "Tapos: {n} hilera. Nabuksan ang file sa bagong tab.",
  "Download (once)": "I-download (isang beses)",
  "Drill-down": "Detalye",
  "E-mail": "E-mail",
  "Edit {code}": "I-edit ang {code}",
  "Effective from": "Epektibo mula",
  "Election spending ban now: {name}, until {end}. Credits are blocked unless a COMELEC exemption covers them.": "May election spending ban ngayon: {name}, hanggang {end}. Bawal ang pag-credit maliban kung may exemption ng COMELEC.",
  "Every barangay with credits has at least one accredited merchant.": "Bawat barangay na may credit ay may kahit isang accredited na tindahan.",
  "Every file states who generated it and when. LGU name only, no officials.": "Nakasaad sa bawat file kung sino at kailan ito ginawa. Pangalan lang ng LGU, walang opisyal.",
  "Everything matches.": "Tugma ang lahat.",
  "Evidence {n}": "Ebidensya {n}",
  "Excel": "Excel",
  "Excel file": "Excel file",
  "Expired": "Nag-expire",
  "Export Excel": "I-export sa Excel",
  "Flag": "Flag",
  "Flagged": "Na-flag",
  "Flags": "Mga flag",
  "For a store owner who applies at the LGU office. The owner then completes the documents and accepts the agreement from their own account.": "Para sa may-ari na nag-apply sa opisina ng LGU. Kukumpletuhin ng may-ari ang mga dokumento at tatanggapin ang kasunduan sa sariling account.",
  "For example maintenance medicine: at most 30 tablets every 30 days.": "Halimbawa, maintenance na gamot: hanggang 30 tableta bawat 30 araw.",
  "For example the DTI suggested retail price or the price ceiling.": "Halimbawa, ang SRP ng DTI o ang price ceiling.",
  "Form": "Anyo",
  "Format": "Format",
  "Found": "Natagpuan",
  "Fraud flags": "Mga fraud flag",
  "From": "Mula",
  "From {a} to {b}": "Mula {a} hanggang {b}",
  "Full account (this view is recorded in the audit log)": "Buong account (nakatala ito sa audit log)",
  "Generate": "Gumawa",
  "Generate and open": "Gumawa at buksan",
  "Generic name": "Generic na pangalan",
  "Give these to the owner in person. The temporary password is shown only once; the owner must change it at first sign-in.": "Ibigay ito nang personal sa may-ari. Isang beses lang ipinapakita ang pansamantalang password; papalitan ito ng may-ari sa unang sign-in.",
  "Group by": "Ipangkat ayon sa",
  "Held from billing": "Pinigil sa billing",
  "High": "Mataas",
  "History": "Kasaysayan",
  "Hold": "Ipigil",
  "Hold sale {n}": "Ipigil ang benta {n}",
  "Hold these sales from billing": "Ipigil ang mga bentang ito sa billing",
  "Holdback": "Holdback",
  "Hours": "Oras",
  "How the assistance is used, by store, item and barangay.": "Paano ginagamit ang ayuda, ayon sa tindahan, item at barangay.",
  "Import Excel": "Mag-import ng Excel",
  "Import products from Excel": "Mag-import ng produkto mula sa Excel",
  "Import {n} rows": "I-import ang {n} hilera",
  "Imported. {e} rows had errors and were skipped.": "Na-import. {e} hilera ang may mali at nilaktawan.",
  "Inspected on": "Siniyasat noong",
  "Inspection": "Inspeksyon",
  "Investigate": "Imbestigahan",
  "Invoice no.": "Blg. ng invoice",
  "It stops working at once. The owner can register a new one.": "Titigil agad ito. Puwedeng magrehistro ng bago ang may-ari.",
  "Item": "Item",
  "Item mappings": "Mga item mapping",
  "Items": "Mga item",
  "Items in {c}": "Mga item sa {c}",
  "Last seen": "Huling nakita",
  "Last sign-in": "Huling sign-in",
  "Leave empty to take effect now.": "Iwanang blangko para magsimula ngayon.",
  "Location": "Lokasyon",
  "Low": "Mababa",
  "Mark OK": "Markahang OK",
  "Max {qty} per {days} days": "Hanggang {qty} bawat {days} araw",
  "Medium": "Katamtaman",
  "Merchant": "Tindahan",
  "Merchant created": "Nagawa ang tindahan",
  "Merchant number": "Numero ng tindahan",
  "Merchants": "Mga tindahan",
  "Merchants selling {i}": "Mga tindahang nagbebenta ng {i}",
  "Merchants with a risk score of {n} or more. Inspect these first.": "Mga tindahang may risk score na {n} pataas. Siyasatin muna ang mga ito.",
  "Method": "Paraan",
  "Mobile": "Mobile",
  "Mobile number": "Mobile number",
  "My export requests": "Aking mga export request",
  "Net claimed": "Netong siningil",
  "Next step": "Susunod na hakbang",
  "No approved products yet.": "Wala pang aprubadong produkto.",
  "No barangays.": "Walang barangay.",
  "No billings yet.": "Wala pang billing.",
  "No credits yet.": "Wala pang credit.",
  "No devices registered.": "Walang nakarehistrong device.",
  "No documents uploaded yet.": "Wala pang na-upload na dokumento.",
  "No flags. All quiet.": "Walang flag. Tahimik ang lahat.",
  "No map pin yet. The public directory needs one.": "Wala pang pin sa mapa. Kailangan ito ng pampublikong directory.",
  "No merchant": "Walang tindahan",
  "No merchant is on the watch list.": "Walang tindahan sa watch list.",
  "No merchants match these filters.": "Walang tindahang tugma sa mga filter.",
  "No programs yet.": "Wala pang programa.",
  "No purchases in this view.": "Walang bili sa view na ito.",
  "No redemptions yet.": "Wala pang redemption.",
  "No sales in this period.": "Walang benta sa panahong ito.",
  "No users.": "Walang user.",
  "None": "Wala",
  "None. Large exports need approval first; requests appear here.": "Wala. Kailangan muna ng pag-apruba ang malalaking export; lalabas dito ang mga request.",
  "Not accepted": "Hindi pa tinatanggap",
  "Not on the current list": "Wala sa kasalukuyang listahan",
  "Not yet": "Hindi pa",
  "Not yet billed": "Hindi pa na-bill",
  "Note": "Tala",
  "Note to the store": "Tala para sa tindahan",
  "Notes": "Mga tala",
  "Nothing for your role to do here.": "Walang gagawin ang iyong tungkulin dito.",
  "Nothing in this period yet.": "Wala pa sa panahong ito.",
  "Nothing recorded yet.": "Wala pang naitala.",
  "Nothing waiting for review.": "Walang naghihintay ng pagsusuri.",
  "Only these items can be paid with assistance. Prices above the cap are refused or capped, per program.": "Ang mga item lang na ito ang puwedeng bayaran ng ayuda. Ang presyong lampas sa cap ay tinatanggihan o nililimitahan, ayon sa programa.",
  "Open": "Bukas",
  "Open and under investigation": "Bukas at iniimbestigahan",
  "Over time": "Sa paglipas ng panahon",
  "Owner": "May-ari",
  "Owner e-mail": "E-mail ng may-ari",
  "Owner name": "Pangalan ng may-ari",
  "Owner sign-in e-mail": "E-mail ng may-ari sa sign-in",
  "POS devices": "Mga POS device",
  "Paid": "Bayad na",
  "Paid above cap": "Binayaran nang lampas sa cap",
  "Paid by the LGU": "Binayaran ng LGU",
  "Payment": "Bayad",
  "Payment list": "Listahan ng bayad",
  "Payment list (Excel)": "Listahan ng bayad (Excel)",
  "Per number of days": "Bawat ilang araw",
  "Period": "Panahon",
  "Pickup at": "Kunin sa",
  "Pickup location": "Lugar ng pagkuha",
  "Prescription": "Reseta",
  "Prescription only": "May reseta lang",
  "Price cap": "Takdang presyo",
  "Price cap (₱ per unit)": "Takdang presyo (₱ bawat isa)",
  "Price vs cap": "Presyo laban sa cap",
  "Profile": "Profile",
  "Program": "Programa",
  "Program and category": "Programa at kategorya",
  "Quantity": "Dami",
  "Quantity limit": "Limitasyon sa dami",
  "Reason": "Dahilan",
  "Reason (the merchant sees this)": "Dahilan (makikita ng tindahan)",
  "Reason (the owner sees this)": "Dahilan (makikita ng may-ari)",
  "Reason for the change": "Dahilan ng pagbabago",
  "Reconciliation": "Reconciliation",
  "Record inspection": "Itala ang inspeksyon",
  "Recorded": "Naitala",
  "Redeemed": "Na-redeem",
  "Redeemed by constituents": "Na-redeem ng mga constituent",
  "Redemptions = billed = paid. Anything that does not match is listed here.": "Redemptions = na-bill = nabayaran. Nakalista dito ang anumang hindi tugma.",
  "Refunds in this billing": "Mga refund sa billing na ito",
  "Registered": "Nakarehistro",
  "Registered constituents": "Mga rehistradong constituent",
  "Registration no.": "Blg. ng rehistro",
  "Reject": "Tanggihan",
  "Reject application": "Tanggihan ang aplikasyon",
  "Reject this mapping?": "Tanggihan ang mapping na ito?",
  "Rejected": "Tinanggihan",
  "Release the holdback": "Ilabas ang holdback",
  "Release {a}": "Ilabas ang {a}",
  "Remove from the list": "Alisin sa listahan",
  "Reports": "Mga ulat",
  "Request sent": "Naipadala ang request",
  "Retire product": "Itigil ang produkto",
  "Review note": "Tala ng pagsusuri",
  "Revoke": "Bawiin",
  "Revoke this device?": "Bawiin ang device na ito?",
  "Risk score": "Risk score",
  "Row": "Hilera",
  "Rule": "Tuntunin",
  "Rules": "Mga tuntunin",
  "Run checks now": "Magsuri ngayon",
  "Sale": "Benta",
  "Sales": "Mga benta",
  "Save as new version": "I-save bilang bagong bersyon",
  "Save inspection": "I-save ang inspeksyon",
  "Save pin": "I-save ang pin",
  "Saving makes a new version. Sales already made keep the old one.": "Gagawa ng bagong bersyon ang pag-save. Mananatili sa luma ang mga nagawang benta.",
  "Search generic name, brand, code or barcode": "Hanapin ang generic na pangalan, brand, code o barcode",
  "Search item name, barcode or product code": "Hanapin ang pangalan ng item, barcode o product code",
  "Search name, owner, number or accreditation no.": "Hanapin ang pangalan, may-ari, numero o blg. ng akreditasyon",
  "Sent. When it is approved, download it from My export requests.": "Naipadala. Kapag naaprubahan, i-download ito sa Aking mga export request.",
  "Separate several with commas.": "Paghiwalayin ng kuwit.",
  "Served": "Napagsilbihan",
  "Set map pin": "Maglagay ng pin",
  "Severity": "Bigat",
  "Share": "Bahagi",
  "Show full bank account": "Ipakita ang buong bank account",
  "Show the numbers": "Ipakita ang mga numero",
  "Size": "Laki",
  "Some merchants have differences. Check the rows marked below.": "May mga pagkakaiba sa ilang tindahan. Suriin ang mga minarkahang hilera sa ibaba.",
  "Spending by category": "Gastos ayon sa kategorya",
  "Spent": "Nagastos",
  "Spent (dashed line)": "Nagastos (putol-putol na linya)",
  "Spent at merchants": "Nagastos sa mga tindahan",
  "Spent {s}, unspent {u}": "Nagastos {s}, natitira {u}",
  "Start evaluation": "Simulan ang pagsusuri",
  "Start from the Excel export so the columns match. The file is checked first; rows with errors are never imported.": "Magsimula sa Excel export para tugma ang mga column. Susuriin muna ang file; hindi kailanman ini-import ang mga hilerang may mali.",
  "Status": "Status",
  "Status history": "Kasaysayan ng status",
  "Still missing": "Kulang pa",
  "Still owed": "Utang pa",
  "Store": "Tindahan",
  "Store inspection": "Inspeksyon ng tindahan",
  "Store inspection not recorded": "Hindi pa naitala ang inspeksyon",
  "Store location": "Lokasyon ng tindahan",
  "Store's item": "Item ng tindahan",
  "Stores accredited to accept assistance, and those applying.": "Mga tindahang accredited tumanggap ng ayuda, at mga nag-a-apply.",
  "Strength": "Lakas",
  "Supervisor": "Supervisor",
  "Supporting list": "Listahang sumusuporta",
  "Suspended: sales are blocked and open billings are on hold.": "Suspendido: bawal ang benta at nakabinbin ang mga bukas na billing.",
  "TIN": "TIN",
  "Tap the map where the store is.": "I-tap sa mapa kung nasaan ang tindahan.",
  "Temporary password": "Pansamantalang password",
  "The cashier must confirm the prescription was seen.": "Dapat kumpirmahin ng kahera na nakita ang reseta.",
  "The owner has not accepted the current agreement (MOA {v})": "Hindi pa tinatanggap ng may-ari ang kasalukuyang kasunduan (MOA {v})",
  "The store price is above the cap. Depending on the program, the till refuses it or charges only the cap.": "Lampas sa cap ang presyo ng tindahan. Depende sa programa, tatanggihan ito ng POS o cap lang ang sisingilin.",
  "This billing is paid.": "Bayad na ang billing na ito.",
  "This export has {rows} rows. Above {limit} rows the Data Privacy Act rules need an approved request. Say why you need it; someone with approval rights will decide.": "May {rows} hilera ang export na ito. Lampas sa {limit} hilera, kailangan ng aprubadong request ayon sa Data Privacy Act. Sabihin kung bakit kailangan; magpapasya ang may karapatang mag-apruba.",
  "This item cannot be on the list: alcohol, tobacco, vape and gambling items are excluded by policy.": "Hindi puwede sa listahan ang item na ito: hindi kasama ang alak, sigarilyo, vape at sugal ayon sa patakaran.",
  "Tick sales to hold out of this billing when approving. Held sales stay unbilled until cleared.": "Lagyan ng tsek ang mga bentang ipipigil kapag nag-apruba. Mananatiling hindi na-bill ang mga ito hanggang ma-clear.",
  "To": "Hanggang",
  "Top items": "Mga pangunahing item",
  "Total redeemed in this view: {a}": "Kabuuang na-redeem sa view na ito: {a}",
  "Transactions": "Mga transaksyon",
  "Type": "Uri",
  "Unpaid billings by age (days)": "Mga hindi pa bayad na billing ayon sa edad (araw)",
  "Unspent": "Natitira",
  "Unspent balances": "Natitirang balanse",
  "Unusual activity found by the nightly and real-time checks. A flag is a lead, not proof.": "Kakaibang aktibidad na nakita ng gabi-gabi at real-time na pagsusuri. Palatandaan lang ang flag, hindi patunay.",
  "Update inspection": "I-update ang inspeksyon",
  "Updated {t}. Refreshes every few minutes.": "Na-update {t}. Nagre-refresh bawat ilang minuto.",
  "Uploaded": "Na-upload",
  "Users": "Mga user",
  "Valid until": "Balido hanggang",
  "Version history": "Kasaysayan ng bersyon",
  "Versions of {code}": "Mga bersyon ng {code}",
  "View": "View",
  "Waiting for review": "Naghihintay ng pagsusuri",
  "Warn, suspend or reinstate": "Babalaan, suspendihin o ibalik",
  "Watch list": "Watch list",
  "Week": "Linggo",
  "What": "Ano",
  "Who": "Sino",
  "With full account numbers": "May buong account number",
  "Your role cannot run this report.": "Hindi pinapayagan ng iyong tungkulin ang ulat na ito.",
  "cap": "cap",
  "e.g. Amlodipine, Rice (well-milled)": "hal. Amlodipine, Bigas (well-milled)",
  "e.g. Treasurer's Office, window 3": "hal. Opisina ng Ingat-yaman, bintana 3",
  "invoice": "invoice",
  "never": "hindi pa",
  "now": "ngayon",
  "prescription only": "may reseta lang",
  "refunded": "na-refund",
  "see fraud flags": "tingnan ang mga fraud flag",
  "tablet, syrup, sack": "tableta, syrup, sako",
  "to": "hanggang",
  "valid until": "balido hanggang",
  "{a} pending, {p} paid so far": "{a} nakabinbin, {p} nabayaran na",
  "{c} of {b}": "{c} sa {b}",
  "{d} days old": "{d} araw na",
  "{g} gross less {r} refunds": "{g} gross bawas {r} refund",
  "{h} held back for review": "{h} pinigil para sa pagsusuri",
  "{n} active": "{n} aktibo",
  "{n} barangays have credited constituents but no accredited merchant.": "{n} barangay ang may na-credit na constituent pero walang accredited na tindahan.",
  "{n} fraud flags touch this billing. Flagged sales are pre-selected to be held when you approve.": "{n} fraud flag ang may kinalaman sa billing na ito. Nakapili na ang mga na-flag na benta para ipigil kapag nag-apruba.",
  "{n} rows, asked {d}": "{n} hilera, hiniling {d}",
  "{n} selected sales will be held out of this billing.": "{n} napiling benta ang ipipigil sa billing na ito.",
  "{ok} rows are ready, {e} have errors.": "{ok} hilera ang handa, {e} ang may mali.",
  "{p}% of budget": "{p}% ng badyet",
  "{q} units, average price {a}": "{q} piraso, karaniwang presyo {a}",
  "{q} units, average {a}, lowest {lo}, highest {hi}, cap {c}": "{q} piraso, karaniwan {a}, pinakamababa {lo}, pinakamataas {hi}, cap {c}",
  "{s} sales, {q} units. Tap to see items.": "{s} benta, {q} piraso. I-tap para makita ang mga item.",
  "Pharmacy": "Botika",
  "Grocery": "Grocery",
  "Sari-sari store": "Sari-sari store",
  "Other": "Iba pa",
  "Draft": "Draft",
  "Submitted": "Naisumite",
  "Under evaluation": "Sinusuri",
  "Accredited": "Accredited",
  "Suspended": "Suspendido",
  "Revoked": "Binawi",
  "Under review": "Sinusuri",
  "On hold": "Nakabinbin",
  "For payment": "Para sa bayad",
  "Released to bank": "Naipadala sa bangko",
  "Check ready for pickup": "Handa na ang tseke",
  "Cancelled": "Kinansela",
  "Warn": "Babalaan",
  "Suspend": "Suspendihin",
  "Revoke accreditation": "Bawiin ang akreditasyon",
  "Reinstate": "Ibalik",
  "Suspend (blocks sales, holds billings)": "Suspendihin (bawal ang benta, pigil ang billing)",
  "Submit": "Isumite",
  "Evaluate": "Suriin",
  "Expire": "Mag-expire",
  "Warning": "Babala",
  "Appeal": "Apela",
  "Stocks items on the approved product list": "May tindang item mula sa aprubadong listahan",
  "Prices are displayed": "Nakadispley ang mga presyo",
  "Store is clean and hygienic": "Malinis ang tindahan",
  "Medicines stored properly (temperature, away from sunlight)": "Maayos ang pagtatago ng gamot (temperatura, malayo sa araw)",
  "Licensed pharmacist present (pharmacies)": "May lisensyadong pharmacist (botika)",
  "Has an Android phone with NFC for the POS": "May Android phone na may NFC para sa POS",
  "address": "address",
  "barangay": "barangay",
  "phone": "telepono",
  "email": "e-mail",
  "bank account for payment": "bank account para sa bayad",
  "Add": "Idagdag",
  "Update": "I-update",
  "Added": "Naidagdag",
  "Updated": "Na-update",
  "Card used many times in a day": "Maraming beses ginamit ang card sa isang araw",
  "Card used at many stores in a day": "Ginamit ang card sa maraming tindahan sa isang araw",
  "Same card at two stores within minutes": "Parehong card sa dalawang tindahan sa loob ng ilang minuto",
  "Sales seconds apart at one store": "Mga bentang ilang segundo lang ang pagitan sa isang tindahan",
  "Sale outside store hours": "Benta sa labas ng oras ng tindahan",
  "Many round amounts": "Maraming bilog na halaga",
  "Many identical amounts": "Maraming magkaparehong halaga",
  "Redemptions far above similar stores": "Redemption na mas mataas kumpara sa katulad na tindahan",
  "High void or refund rate": "Mataas na void o refund",
  "Whole balance spent right after crediting": "Naubos ang buong balanse pagka-credit",
  "Repeated wrong PINs": "Paulit-ulit na maling PIN",
  "Card-less purchases used too often": "Masyadong madalas ang bili nang walang card",
  "Beneficiary list": "Listahan ng benepisyaryo",
  "Credit batches": "Mga credit batch",
  "Redemptions per merchant": "Mga redemption bawat tindahan",
  "Billing and payments": "Billing at bayad",
  "Expired credits": "Mga nag-expire na credit",
  "Card issuance and replacements": "Paglabas at pagpapalit ng card",
  "SMS cost per program": "Gastos sa SMS bawat programa",
  "Audit log extract": "Bahagi ng audit log",
  "Everyone credited under a program, with an acknowledgement column for COA.": "Lahat ng na-credit sa isang programa, may column ng pagkilala para sa COA.",
  "Credit batches with their approvals and obligation/voucher references.": "Mga credit batch kasama ang mga pag-apruba at reference ng obligation/voucher.",
  "What constituents bought, per merchant.": "Ang binili ng mga constituent, bawat tindahan.",
  "Merchant billings and payments with bank references.": "Mga billing at bayad sa tindahan kasama ang reference ng bangko.",
  "Credits that expired, for budget reversion.": "Mga credit na nag-expire, para sa pagbabalik ng badyet.",
  "Cards printed, released, blocked and replaced.": "Mga card na na-print, naibigay, na-block at napalitan.",
  "SMS sent and their cost per program.": "Mga SMS na naipadala at gastos bawat programa.",
  "An extract of the audit trail.": "Bahagi ng audit trail.",
};
